import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { media } from 'src/config/breakpoints';
import { colors, shadows } from 'src/config/colors';
import { CleanButton } from 'src/common/components/Button';
import { typography } from 'src/config/typography';
import LogoutIcon from 'src/assets/icons/LogoutIcon';
import { LogoutRoute } from 'src/public/publicRoutes';
import { layers } from 'src/config/layers';
import { useSelector } from 'react-redux';
import { layoutActivePanelCategorySelector } from 'src/state/layout/layoutSelectors';
import { userProfileMenuItems } from 'src/user/common/models/userProfileMenuItem';
import { GatsbyLink } from 'src/common/migration/GatsbyLink';
import { translatedPathnames } from 'src/config/routes';

const Box = styled.div`
  background: ${colors.white};
  border-radius: 0.25rem;
  box-shadow: ${shadows.drop1};
  display: flex;
  height: 4rem;
  justify-content: space-between;
  overflow: hidden;
  padding: 0.5rem 0 0.4375rem;
`;

const Container = styled.div`
  bottom: 0;
  left: 50%;
  max-width: 100%;
  padding: 0 0.75rem;
  position: fixed;
  transform: translate3d(-50%, 0, 0);
  width: 22.5rem;
  z-index: ${layers.widget};
  -webkit-backface-visibility: hidden;

  ${media.w.min.px992(css`
    display: none;
  `)};
`;

const CategoryIcon = styled.svg`
  flex: 0 0 auto;
`;

const CategoryItem = styled(CleanButton)<{ $active?: boolean }>`
  align-items: center;
  color: ${({ $active }) => ($active ? colors.red : colors.blue)};
  display: flex;
  flex: 0 1 5.25rem;
  flex-direction: column;
  padding: 0 0.3125rem;
  text-align: center;
  white-space: normal;

  &:last-child {
    margin-right: auto;
  }
`;

const CategoryTitle = styled.span`
  align-items: center;
  color: ${colors.blue};
  display: flex;
  flex: 1 1 auto;
  font-family: ${typography.fontFamilyHeaders};
  font-size: 0.625rem;
  line-height: 0.75rem;
  margin-top: 0.4375rem;
`;

export const UserPageMobileMenu: FC = () => {
  const activeCategory = useSelector(layoutActivePanelCategorySelector);

  return (
    <Container>
      <Box>
        {userProfileMenuItems.map((category) => (
          <CategoryItem
            $active={
              activeCategory
                ? (translatedPathnames[activeCategory] ?? activeCategory) === category.id
                : false
            }
            as={GatsbyLink}
            key={category.id}
            to={category.url}
          >
            <CategoryIcon as={category.icon} size={18} />
            <CategoryTitle dangerouslySetInnerHTML={{ __html: category.mobileTitle }} />
          </CategoryItem>
        ))}

        <CategoryItem as={GatsbyLink} to={LogoutRoute}>
          <CategoryIcon as={LogoutIcon} size={18} />
          <CategoryTitle>Wyloguj się</CategoryTitle>
        </CategoryItem>
      </Box>
    </Container>
  );
};
